export default {"src":"/_next/static/media/icone-quark.4e99f917.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};